

import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
  public store: string;
  public currWeekDay: number;
  public currDay: number;
  public currMonth: number;
  public currYear: number;

  public calendarDay: DateTime | null;
  public calendarMonth: number;
  public calendarYear: number;
  public calendarWeekDay: number;
  public calendarDaysInMonth: number;
  public today: DateTime;
  public currStartDay: number;

  constructor(public dialogRef: MatDialogRef<DatePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      trigger: ElementRef,
      date: DateTime,
      escludiGiorni: number[],
      escludiDate: DateTime[],
      lang: string,
      daData: DateTime,
      aData: DateTime,
      consentiPassato: boolean
    }) {

    this.store = '';
    this.currWeekDay = 0;
    this.currDay = 0;
    this.currMonth = 0;
    this.currYear = 0;
    this.calendarDay = null;
    this.calendarMonth = 0;
    this.calendarYear = 0;
    this.calendarWeekDay = 0;
    this.calendarDaysInMonth = 0;
    this.currStartDay = 0;

    if (data.date) {
      this.today = data.date;
    } else {
      this.today = DateTime.local();
    }
    if (this.data.consentiPassato === undefined || this.data.consentiPassato === null)
      this.data.consentiPassato = false;
  }
  async refreshCalendar(month: number, year: number) {
    this.calendarMonth = month;
    this.calendarYear = year;
    this.calendarDay = DateTime.local(this.calendarYear, this.calendarMonth, 1);

    this.calendarWeekDay = this.calendarDay.weekday;
    this.currStartDay = this.calendarWeekDay;
    if (this.data.lang === 'EN') {
      switch (this.calendarWeekDay) {
        case 7: this.currStartDay = 1; break;
        case 1: this.currStartDay = 2; break;
        case 2: this.currStartDay = 3; break;
        case 3: this.currStartDay = 4; break;
        case 4: this.currStartDay = 5; break;
        case 5: this.currStartDay = 6; break;
        case 6: this.currStartDay = 7; break;
      }
    } else {
      switch (this.calendarWeekDay) {
        case 7: this.currStartDay = 7; break;
        case 1: this.currStartDay = 1; break;
        case 2: this.currStartDay = 2; break;
        case 3: this.currStartDay = 3; break;
        case 4: this.currStartDay = 4; break;
        case 5: this.currStartDay = 5; break;
        case 6: this.currStartDay = 6; break;
      }
    }

    this.calendarDaysInMonth = this.daysInMonth(this.calendarMonth, this.calendarYear);
  }
  async ngOnInit() {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    const rect = this.data.trigger.nativeElement.getBoundingClientRect();

    if (this.data.date)
      this.data.date = DateTime.fromISO(this.data.date.toISO());

    if (this.data.daData)
      this.data.daData = DateTime.fromISO(this.data.daData.toISO());

    if (this.data.aData)
      this.data.aData = DateTime.fromISO(this.data.aData.toISO());

    if (this.data.escludiDate) {
      this.data.escludiDate.forEach(data => {
        data = DateTime.fromISO(data.toISO());
      });
    }

    matDialogConfig.position = { left: `${rect.left}px`, top: `${rect.bottom}px` };
    this.dialogRef.updatePosition(matDialogConfig.position);
    this.setCurrDay(this.today);
    this.refreshCalendar(this.today.month, this.today.year);

  }

  async setCurrDay(day: DateTime) {
    this.currDay = day.day;
    this.currMonth = day.month;
    this.currYear = day.year;
    this.currWeekDay = day.weekday;

  }

  day(num: number): string {
    if (num >= this.currStartDay && num < this.currStartDay + this.calendarDaysInMonth) {
      return (num - this.currStartDay + 1).toString();
    } else {
      return '';
    }
  }

  shortWeekDay(num: number) {
    if (this.data.lang === 'EN') {

    }
    return 0;
  }
  weekDay(num: number) {
    if (this.data.lang !== 'EN') {
      for (let i = 0; i < 7; i++) {
        if (num === 1 + i || num === 8 + i || num === 15 + i || num === 22 + i || num === 29 + i || num === 36 + i) {
          return i;
        }
      }
    } else {
      for (let i = 0; i < 7; i++) {
        if (num === 1 + i || num === 8 + i || num === 15 + i || num === 22 + i || num === 29 + i || num === 36 + i) {
          if (i === 0) {
            return 6;
          } else {
            return i - 1;
          }
        }
      }
    }
    return -1;
  }
  dayHeaderClass(num: number) {
    let cls = '';
    const weekday = this.weekDay(num);
    if (this.data.escludiGiorni && this.data.escludiGiorni.length > 0 && this.data.escludiGiorni.indexOf(weekday) >= 0) {
      cls = 'day-disabled';
    }
    return cls;
  }
  dayClass(num: number) {
    let cls = '';

    if (this.currDay === num - this.currStartDay + 1 && this.currMonth === this.calendarMonth && this.currYear === this.calendarYear) {
      cls = 'day-currday';
    }
    /* if (this.today.day === num - this.currStartDay + 1 && this.currMonth === this.today.month) {
      cls = 'day-today';
    } */
    const weekday = this.weekDay(num);
    const today = DateTime.local();

    if ((this.data.escludiGiorni && this.data.escludiGiorni.length > 0 && this.data.escludiGiorni.indexOf(weekday) >= 0) ||
      (!this.data.consentiPassato && today.day > num - this.currStartDay + 1 && today.month >= this.calendarMonth && today.year >= this.calendarYear) ||
      (!this.data.consentiPassato && today.month > this.calendarMonth && today.year >= this.calendarYear) ||
      (!this.data.consentiPassato && today.year > this.calendarYear)) {
      cls += ' day-disabled';
    }

    if (this.data.escludiDate && this.data.escludiDate.length > 0 && cls.indexOf('day-disabled') < 0) {
      this.data.escludiDate.forEach(data => {
        if (((num - this.currStartDay + 1) == data.day) && this.calendarMonth == data.month && this.calendarYear == data.year) {
          cls += ' day-disabled';
        }
      });
    }

    if (this.data.daData && cls.indexOf('day-disabled') < 0) {
      if ((this.data.daData.day > num - this.currStartDay + 1 && this.data.daData.month === this.calendarMonth && this.data.daData.year === this.calendarYear) ||
        (this.data.daData.month > this.calendarMonth && this.data.daData.year === this.calendarYear) ||
        (this.data.daData.year > this.calendarYear)) {
        cls += ' day-disabled';
      }
    }


    if (this.data.aData && cls.indexOf('day-disabled') < 0) {
      if ((this.data.aData.day < num - this.currStartDay + 1 && this.data.aData.month === this.calendarMonth && this.data.aData.year === this.calendarYear) ||
        (this.data.aData.month < this.calendarMonth && this.data.aData.year === this.calendarYear) ||
        (this.data.aData.year < this.calendarYear)) {
        cls += ' day-disabled';
      }
    }
    /*
    if ((this.data.escludiGiorni && this.data.escludiGiorni.length > 0 && this.data.escludiGiorni.indexOf(weekday) >= 0) ||
        (today.day > num - this.currStartDay + 1 && today.month >= this.calendarMonth && today.year >= this.calendarYear) ||
        (today.month > this.calendarMonth && today.year >= this.calendarYear) ||
        (today.year > this.calendarYear)) {
      cls += ' day-disabled';
    }
    */

    if (num >= this.currStartDay && num < this.currStartDay + this.calendarDaysInMonth) {
      cls += ' day-visible';
    }
    if (num >= this.currStartDay && num < this.currStartDay + this.calendarDaysInMonth) {
      cls += ' day-visible';
    }

    return cls;
  }
  daysInMonth(month: number, year: number) {
    return DateTime.local(year, month).daysInMonth;
  }
  onDay(num: number) {
    if (this.dayClass(num).indexOf('day-disabled') >= 0 || num < this.currStartDay || num >= this.currStartDay + this.calendarDaysInMonth) {
      return;
    }
    const currday = DateTime.local(this.calendarYear, this.calendarMonth, num - this.currStartDay + 1);
    this.setCurrDay(currday);
    this.dialogRef.close(currday);
  }
  prevMonth() {
    if (this.calendarMonth === 1) {
      this.calendarMonth = 12;
      this.calendarYear -= 1;
    } else {
      this.calendarMonth -= 1;
    }
    this.refreshCalendar(this.calendarMonth, this.calendarYear);
  }
  nextMonth() {
    if (this.calendarMonth === 12) {
      this.calendarMonth = 1;
      this.calendarYear += 1;
    } else {
      this.calendarMonth += 1;
    }
    this.refreshCalendar(this.calendarMonth, this.calendarYear);
  }
  getLongMonth(num: number): string {
    let d = '';
    switch (num) {
      case 0: d = 'Dicembre'; break;
      case 1: d = 'Gennaio'; break;
      case 2: d = 'Febbraio'; break;
      case 3: d = 'Marzo'; break;
      case 4: d = 'Aprile'; break;
      case 5: d = 'Maggio'; break;
      case 6: d = 'Giugno'; break;
      case 7: d = 'Luglio'; break;
      case 8: d = 'Agosto'; break;
      case 9: d = 'Settembre'; break;
      case 10: d = 'Ottobre'; break;
      case 11: d = 'Novembre'; break;
      case 12: d = 'Dicembre'; break;
      case 13: d = 'Gennaio'; break;
    }
    return d;
  }
}
